export const copyHandler = (value: string): void => {
    navigator.clipboard.writeText(value)
}
